import { FC } from 'react';
import { LogBox, TextStyle } from 'react-native';
import styled from 'styled-components/native';
import { color, layout, system, typography } from 'styled-system';
import { ColorOptions, FontSizeOptions, FontWeightOptions, LineHeightOptions } from '../../theme/UiThemeProvider';
import { useBreakPointProps } from '../../utils/utils';
import styles from './styles';

LogBox.ignoreLogs(['Expected style "lineHeight'])

const extraConfig = {
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationColor: {
    property: 'textDecorationColor',
    scale: 'colors',
  },
  includeFontPadding: true,
}

const StyledText = styled.Text`
  ${color}
  ${typography}
  ${layout}
  ${system(extraConfig as any)}
`
export type TextTypesOptions = keyof typeof styles
export const TextTypesOptionArray = Object.keys(styles)
type FontWeightValues = 'normal' | 'bold' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900'

export interface TextProps extends Pick<TextStyle, 'textAlign' | 'textDecorationLine' | 'textDecorationStyle'> {
  type?: TextTypesOptions | Array<TextTypesOptions>
  fontSize?: FontSizeOptions | number | Array<FontSizeOptions | number>
  fontWeight?: FontWeightOptions | FontWeightValues | Array<FontWeightOptions | FontWeightValues>
  color?: ColorOptions | Array<ColorOptions>
  textDecorationColor?: ColorOptions | Array<ColorOptions>
  fontFamily?: string
  title?: string
  includeFontPadding?: boolean
  weight?: 'normal' | 'dense' | Array<'normal' | 'dense'>
  numberOfLines?: number | Array<number>
  ellipsizeMode?: 'head' | 'middle' | 'tail' | 'clip'
  width?: number | string | Array<number | string> // Added this
  letterSpacing?: number | Array<number>
  lineHeight?: LineHeightOptions | number | Array<LineHeightOptions | number>
  opacity?: number | Array<number>
  flexShrink?: number
  flex?: number
  testID?: string
  selectable?: boolean
  hide?: boolean
  children?: any
  onPress?: () => void;
}

const Text: FC<TextProps> = (props) => {
  const { children, testID, hide } = props
  const modifiedProps = useBreakPointProps<TextProps>(props)
  const { width, type = 'body16', weight = 'normal', title, ...restProps } = modifiedProps

  if (hide) {
    return null
  }
  return (
    <StyledText testID={testID} width={width} {...styles[type as TextTypesOptions][weight as 'normal' | 'dense']} {...restProps}>
      {children || title}
    </StyledText>
  )
}

Text.defaultProps = {
  selectable: true,
}

export { Text };

